import { Popover, PopoverContent, PopoverTrigger } from '@nextui-org/react'
import { useEffect, useState } from 'react'
import { useOrgUsers } from '~/hooks'
import { User } from '~/types/ResponseType'
import { generateAvatar } from '~/utils/utils'

interface UserPopoverProps {
  userId: number
  userName: string
}

export function UserPopover({ userName, userId }: UserPopoverProps) {
  const [isOpen, setIsOpen] = useState(false)
  const [user, setUser] = useState<User | undefined>()
  const users = useOrgUsers()

  if (!userName || !userId) {
    return null
  }

  const handleMouseEnter = () => {
    setIsOpen(true)
  }

  const handleMouseLeave = () => {
    setIsOpen(false)
  }

  useEffect(() => {
    const userInfo = users.find(user => user.id === userId)

    setUser({
      name: userInfo?.name,
      email: userInfo?.email,
      role: userInfo?.role
    } as User)
  }, [userId, users])

  return (
    <Popover placement='top-start' isOpen={isOpen} onOpenChange={open => setIsOpen(open)}>
      <PopoverTrigger>
        <span
          className='text-link  cursor-pointer'
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          {userName}
        </span>
      </PopoverTrigger>
      <PopoverContent
        className='rounded-md shadow-2xl p-4 border-none ring-1 ring-[#E5E7EB]'
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div className='user-profile flex'>
          <div className='user-profile__avatar mr-4'>
            <img
              src={generateAvatar(user?.name ?? 'Unkown')}
              alt={user?.name ?? 'Unkown'}
              className='h-[40px] w-[40px] rounded'
            />
          </div>
          <div className='user-profile__info'>
            <div className='user-profile__name'>{user?.name ?? 'Unkown'}</div>
            {user?.email ? (
              <div className='user-profile__email text-gray-500'>{user?.email}</div>
            ) : null}
          </div>
        </div>
      </PopoverContent>
    </Popover>
  )
}
